export default "__VITE_ASSET__978YHWPT__"